import axios from "../utils/axios";

/**
 * 全国农产品批发市场价格信息系统 API
 */

// 获取品种大类
const getVarietyMajorCategories = () => {
    return axios({
        method: "post",
        url: "https://open.mini.xiaomaiot.com/datav/v3/frontend/proxy",
        data: {
            url: "https://pfsc.agri.cn/api/priceQuotationController/getVarietyMajorCategories"
        }
    });
};

// 获取品种小类
const getVarietyNameByPid = pid => {
    return axios({
        method: "post",
        url: "https://open.mini.xiaomaiot.com/datav/v3/frontend/proxy",
        data: {
            url: `https://pfsc.agri.cn/api/priceQuotationController/getVarietyNameByPid?pid=${pid}`,
        }
    });
};
// 3
// 获取涉农资讯列表
const getNewsList = () => {
    return axios({
        method: "post",
        url: "https://open.mini.xiaomaiot.com/datav/v3/nyzx/list",
    });
};
// 获取涉农资讯单个详细信息
const getNewsSingle = (data) => {
    return axios({
        method: "post",
        url: "https://open.mini.xiaomaiot.com/datav/v3/nyzx/info",
        data: {"redirect_url":data}
    });
};
// 获取单一品种全国平均价
const getSingleVarietiesCountry = params => {
    let str = "";
    const keys = Object.keys(params);
    for (let key of keys) {
        str += `${key}=${encodeURIComponent(params[key])}&`;
    }
    return axios({
        method: "post",
        url: "https://open.mini.xiaomaiot.com/datav/v3/frontend/proxy",
        data: {
            url: `https://pfsc.agri.cn/api/marketQuotationController/getSingleVarietiesCountry?${str}`,
        }
    });
};

const getFarmCameraList = id => {
    return axios({
        method: "post",
        url: "https://open.mini.xiaomaiot.com/datav/v3/camera_device/list_by_farm_id",
        data: {
          farm_id_list: [id]
        }
    });
};

export {
    getVarietyMajorCategories,
    getVarietyNameByPid,
    getSingleVarietiesCountry,
    getNewsList,
    getNewsSingle,
    getFarmCameraList
};
